import React, { ReactNode } from "react";
import { cn } from "@/utils/utils";

interface Props {
  children: ReactNode;
  className?: string;
}

const KPIsContainer: React.FC<Props> = ({ children, className }) => (
  <div
    className={cn(
      "grid grid-cols-[repeat(auto-fill,minmax(17rem,17rem))] gap-2 w-full p-3 rounded-xl border-[0.5px] border-border-border1",
      className
    )}
    style={{
      background: `linear-gradient(90deg, var(--surface-kpis-container-start) 0.79%, var(--surface-kpis-container-mid) 54.68%, var(--surface-kpis-container-end) 106.64%)`
    }}
  >
    {children}
  </div>
);

export default KPIsContainer;
